import React, { FunctionComponent } from 'react';
import Analytics from 'analytics/client';
import { Events } from 'analytics/events';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { Img } from 'react-image';
import Button from '../UI/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { wbp, reduceResolution } from 'Theme';

interface Props {
    disableAddButton?: boolean;
    onAddClient?: () => void;
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            alignItems: 'center'
        },
        image: {
            [theme.breakpoints.down('lg')]: {
                width: '486px',
                height: '242px'
            },
            [theme.breakpoints.up('xl')]: {
                width: '648px',
                height: '322px'
            }
        },
        title: {
            textAlign: 'center',
            fontWeight: 700,
            [theme.breakpoints.down('lg')]: {
                marginTop: '13px',
                lineHeight: '27px',
                fontSize: '26px'
            },
            [theme.breakpoints.up('xl')]: {
                marginTop: '20px',
                lineHeight: '36px',
                fontSize: '28px'
            }
        },
        description: {
            textAlign: 'center',
            fontWeight: 500,
            [theme.breakpoints.down('lg')]: {
                marginTop: '11px',
                lineHeight: '20px',
                fontSize: '16px'
            },
            [theme.breakpoints.up('xl')]: {
                marginTop: '15px',
                lineHeight: '27px',
                fontSize: '18px'
            }
        },
        button: {
            [theme.breakpoints.down(wbp)]: {
                marginTop: `${reduceResolution(34)}px`,
                marginBottom: `${reduceResolution(34)}px`,
                width: `${reduceResolution(200)}px`,
                height: `${reduceResolution(55)}px`,
                fontSize: `${reduceResolution(18)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginTop: '34px',
                marginBottom: '34px',
                width: '200px',
                height: '55px',
                fontSize: '18px'
            }
        }
    })
);

export const ClientsNotCreated: FunctionComponent<Props> = props => {
    const classes = useStyles();
    const clientsDone = useSelector<RootState, boolean>(state => state.onboardingSteps.onboardingSteps.clientsDone);
    const marketplaceId = useSelector<RootState, number | undefined>(
        state => state.login.auth.marketplaceId || state.marketplace.marketplace?.id
    );

    const handleClick = () => {
        if (!clientsDone) {
            try {
                const key = `event_one_shot_${Events.ADD_CLIENT_CLICKED}_${marketplaceId}`;
                if (marketplaceId && localStorage.getItem(key) !== '1') {
                    Analytics.track(Events.ADD_CLIENT_CLICKED as any, { marketplace_id: marketplaceId });
                    localStorage.setItem(key, '1');
                }
            } catch (e) {
                // non-blocking
            }
        }
        props.onAddClient && props.onAddClient();
    };

    return (
        <Box className={classes.container}>
            <Img
                className={classes.image}
                src="/images/clients/EmptyClients.svg"
            />
            <Typography className={classes.title}>Happy clients will live here.</Typography>
            <Typography className={classes.description}>Start adding your clients.</Typography>
            <Button
                id="clients_button_add"
                label="+ Add Client"
                className={classes.button}
                onClick={handleClick}
                disabled={props.disableAddButton}
            />
        </Box>
    );
};

export default ClientsNotCreated;
